import { API_BASE_URL } from "../utils/api";

const imageCache = new Map();

export const fetchImageWithCache = async (gdriveId) => {
  if (imageCache.has(gdriveId)) {
    return imageCache.get(gdriveId);
  }

  const URL = `${API_BASE_URL}/user/auth/fetchImage`;
  try {
    const response = await fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ gdriveId })
    });

    const data = await response.json();

    // Check for successful status or missing base64
    if (data?.statusCode !== 200 || !data?.data?.base64) {
      throw new Error(data?.message || "Invalid response");
    }

    const result = data.data.base64;
    // Cache the result
    imageCache.set(gdriveId, result);
    return result;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Unknown error";
    throw new Error(message);
  }
};

export default {
  fetchImageWithCache,
};
